export const useWindowWidth = defineStore("window-width", () => {
  const windowWidth = ref<number>(0);

  const updateWindowWidth = () => {
    windowWidth.value = window.innerWidth;
  };

  return { windowWidth, updateWindowWidth };
});
